/**
 * @deprecated These mappers are only used for legacy board items (saved before the
 * row-aware layout algorithm in boardLayoutUtils.js). Legacy items are detected by
 * their column_offset format — if it's a JSON object without a '_spans' key
 * (e.g., {'4': 0, '6': 0}), the item uses this legacy mapping.
 * 
 * New items saved via boardLayoutUtils.js store pre-computed spans for each
 * screen size inside column_offset under the '_spans' key, making these
 * mappers unnecessary for new data.
 * 
 * Do not use in new code — use boardLayoutUtils.js instead.
 */
export const columnSpanToUseMapper = {
    0: {
        "regularScreen": 1,
        "largeScreen": 1
    },
    1: {
        "regularScreen": 1,
        "largeScreen": 2
    },
    2: {
        "regularScreen": 2,
        "largeScreen": 4
    },
    3: {
        "regularScreen": 3,
        "largeScreen": 4
    },
    4: {
        "regularScreen": 4,
        "largeScreen": 6
    },
    5: {
        "regularScreen": 3,
        "largeScreen": 5
    },
    6: {
        "regularScreen": 4,
        "largeScreen": 6
    },
}

/**
 * @deprecated No longer used. The new layout system (boardLayoutUtils.js) stores
 * spans for all screen sizes directly, eliminating the need for a reverse mapper.
 * Kept here only as reference for the original approach.
 */
export const columnSpanToSave = {

    "regularScreen": {
        1: 0,
        2: 2,
        3: 3,
        4: 4,
        5: 4,
        6: 4
    },
    "largeScreen": {
        1: 0,
        2: 1,
        3: 2,
        4: 2,
        5: 5,
        6: 4
    }

}

export const closePortalDefaultTabs = [
    {
        "id": "HOME",
        "label": "Home",
        "name": "Home",
        "isDefault" : true,
        "order" : 1,
        "tabType" : "BOARD",
        "visible" : true
    },
    {
        "id": "AppsLibrary",
        "label": "Application Marketplace",
        "name": "Apps Library",
        "isDefault" : true,
        "order" : 2,
        "tabType" : "APPS",
        "visible" : true
    },
    {
        "id": "EXECUTIVE",
        "label": "Executive",
        "name": "Executive",
        "isDefault" : true,
        "order" : 3,
        "tabType" : "LIST",
        "visible" : true
    },
    {
        "id": "REPORTING",
        "label": "Reporting",
        "name": "Reporting",
        "isDefault" : true,
        "order" : 4,
        "tabType" : "LIST",
        "visible" : true
    },
    {
        "id": "AI/ML",
        "label": "AI/ML",
        "name": "AI/ML",
        "isDefault" : true,
        "order" : 5,
        "tabType" : "LIST",
        "visible" : true
    },
    {
        "id": "JOURNAL ENTRY",
        "label": "Journal Entry",
        "name": "Journal Entry",
        "isDefault" : true,
        "order" : 6,
        "tabType" : "LIST",
        "visible" : true
    },
    {
        "id": "ACCOUNT RECONCILIATION",
        "label": "Account Reconciliation",
        "name": "Account Reconciliation",
        "isDefault" : true,
        "order" : 7,
        "tabType" : "LIST",
        "visible" : true
    },
    {
        "id": "TRACKERS / DELIVERABLES",
        "label": "Trackers/Deliverables",
        "name": "Trackers/Deliverables",
        "isDefault" : true,
        "order" : 8,
        "tabType" : "LIST",
        "visible" : true
    },
]

export const quillFormFieldModules = { toolbar: [['bold', 'italic', 'underline'], [{ 'size': ['small', false, 'large'] }], ['link']] };
export const quillFormFieldFormats = ['bold', 'italic', 'underline', 'size', 'link'];

export const URL_PATTERN = /^https?:\/\/\S+$/;

export const tabTypes = {
    BOARD : "BOARD",
    LIST : "LIST"
}

export const SANITIZE_ALLOWED_TAGS = ['b', 'i', 'u', 'em', 'strong', 'span', 'p', 'br', 'a'];
export const SANITIZE_ALLOWED_ATTRIBUTES = ['href', 'target', 'rel', 'class'];

export const STATIC_RESOURCES = {
    AMAZON_NEWS : "https://www.aboutamazon.com/",
    ALLOCATIONS : "https://website.prod.iad.spectra.fintech.amazon.dev/#/",
    REPORT_CENTRL : "https://www.report-central.fintech.amazon.dev/",
    FIRST_PASS_PRO : "https://beta.bi-central.accounting.amazon.dev/Firstpass",
}

export const ENV_SPECIFIC_RESOURCES = {
    BOFFIN : {
        "dev" : "https://beta.bi-central.accounting.amazon.dev/BoffinHome",
        "beta" : "https://beta.bi-central.accounting.amazon.dev/BoffinHome",
        "prod" : "https://bi-central.accounting.amazon.dev/BoffinHome"
    },
    TED : {
        "dev" : "https://beta.bi-central.accounting.amazon.dev/TEDHome",
        "beta" : "https://beta.bi-central.accounting.amazon.dev/TEDHome",
        "prod" : "https://bi-central.accounting.amazon.dev/TEDHome"
    },
    SEC_CENTRAL : {
        "dev" : "https://beta.bi-central.accounting.amazon.dev/CorpReportingHome",
        "beta" : "https://beta.bi-central.accounting.amazon.dev/CorpReportingHome",
        "prod" : "https://bi-central.accounting.amazon.dev/CorpReportingHome"
    }
}